<template>
    <b-form @submit="handleSubmit">

        <organization-billing-form-inputs :organization="organization" ref="orgInputs"/>

        <b-row class="mt-4 mb-2">
            <b-col class="ml-auto" cols="auto">
                <b-button variant="light"
                          class="btn-rounded px-3"
                          @click="$emit('cancel')"
                          :disabled="saving">
                    Cancel
                </b-button>
                <b-button variant="primary"
                          class="btn-rounded px-3"
                          type="submit"
                          :disabled="saving">
                    <span v-if="saving">Please Wait...</span>
                    <span v-else>Save</span>
                </b-button>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>


import OrganizationBillingFormInputs from "./OrganizationBillingFormInputs";

export default {
  components: {OrganizationBillingFormInputs},
  props: ['organization', 'saving'],

  methods: {
    handleSubmit: function (evt) {
      evt.preventDefault();
      this.$emit('save', this.$refs.orgInputs.params);
    }
  }
}
</script>